<template>
	<div class="menu_box border_bottom_dashed" :style="laborAddress?'border-top:1px solid #E4E7ED;border-bottom: none;':'border-top:none;border-bottom: none;'">
		<div class="flex borderBottomDashed paddingAll20">
			<div class="title_shaixuan flex_jc_center">股东性质</div>
			<div class="classified_content" :style="{height:show?'auto':'46px'}" ref="height">
        <div class="unfold flex_ai_center" :class="show?'unfold-red':''" @click="show=!show" v-if="height">
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
				<span v-for="(item, index) in enterpriseType" :key="'enterprise'+index" :class="{ pitch_on: teamIndex==index }" @click="send(item, index)">
					{{ item.label }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
  import {apiLaborServiceCompany} from "@/api/apiLaborServiceCompany"
	export default {
		name: "enterpriseType",
		props: {
			laborAddress: {
			type: Boolean,
			default: false
			},
		},
		data() {
			return {
				enterpriseType: [],
				teamIndex: '',
        show:true,
        height:false,
			}
		},
		watch: {},
		created() {
			this.findCategoryListTree()
		},
		methods: {
      /** @name获得筛选分类 */
      async findCategoryListTree() {
        if(!this.$store.state.HC_enterpriseType){
          let res = await apiLaborServiceCompany.getCompanyType()
          this.enterpriseType = [{id:'',label:'全部'},...res.data.data];
          this.$store.state.HC_enterpriseType = [{id:'',label:'全部'},...res.data.data];
        }else{
          this.enterpriseType = this.$store.state.HC_enterpriseType
        }
        this.$nextTick(v=>{
          this.height=this.$refs.height.offsetHeight>46;
          this.show=!this.height;
        })
      },
			/** @name 搜索单项 */
			send(obj, key) {
        this.teamIndex = key;
        if(key==0){
          this.$parent.$refs.screen.enterpriseType=[]
          return
        }
        obj.key = key;
				//替换搜索项
				let type = this.$parent.$refs.screen.enterpriseType.length;
				if (type) {
					this.$parent.$refs.screen.enterpriseType.splice(0, 1, obj)
					return
				}
				//添加搜索项
				this.$parent.$refs.screen.enterpriseType.push(obj)
			},
			/** @name 清队单项 */
			close(item) {
				this.teamIndex = ''
			},
			/** @name 清空所有 */
			closeall() {
				this.teamIndex = ''
			}
		},
	}
</script>

<style scoped>

</style>
